'use strict';

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports["default"] = translate;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _i18nContext = require('./i18n-context');

var _i18nContext2 = _interopRequireDefault(_i18nContext);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // higher order decorator for components that need `t`


function translate() {
  return function (WrappedComponent) {
    var _translate = function _translate(props) {
      return _react2["default"].createElement(_i18nContext2["default"].Consumer, null, function (t) {
        return _react2["default"].createElement(WrappedComponent, _extends({}, props, {
          t: t
        }));
      });
    };

    return (0, _hoistNonReactStatics2["default"])(_translate, WrappedComponent);
  };
}